import {
  CategorySchema,
  CategoryFullSchema,
  CategoryUpdateSchema,
  GetCategoriesParams,
  GetCategoryRequest,
  UpdateCategoryRequest,
} from '@/types/categories';
import { api } from './index';

class CategoriesService {
  // --------------------------------------- V3 - VERSION 3 ------------------------------------------

  /**
   * Get all categories (V3)
   * GET /v3/categories/
   * NEW IN V3 ✅
   */
  async getCategories(params?: GetCategoriesParams): Promise<CategorySchema[]> {
    try {
      const response = await api.get('/categories/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching categories (V3):', error);
      throw error;
    }
  }

  /**
   * Get specific category by ID (V3)
   * GET /v3/categories/{category_id}
   * NEW IN V3 ✅
   */
  async getCategory(request: GetCategoryRequest): Promise<CategoryFullSchema> {
    try {
      const response = await api.get(`/categories/${request.categoryId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching category ${request.categoryId} (V3):`, error);
      throw error;
    }
  }

  /**
   * Update category (V3)
   * PATCH /v3/categories/{category_id}
   * NEW IN V3 ✅
   */
  async updateCategory(request: UpdateCategoryRequest): Promise<CategoryFullSchema> {
    try {
      const { categoryId, ...updateData } = request;
      const response = await api.patch(`/categories/${categoryId}`, updateData);
      return response.data;
    } catch (error) {
      console.error(`Error updating category ${request.categoryId} (V3):`, error);
      throw error;
    }
  }
}

export const categoriesService = new CategoriesService();
